<h5>{{ "Template.SupplierContactComponent.subHeader_contactPerson" | translate }}</h5>

@if (type == 'SUPPLIER_DATA') {
  <h6>{{ "Template.SupplierContactComponent.subHeader_forDataAccesses" | translate }}</h6>
}
@if (type == 'SUPPLIER_ORDERS') {
  <h6>{{ "Template.SupplierContactComponent.subHeader_forOrderAccesses" | translate }}</h6>
}

<p>
  <small>{{ "Template.SupplierContactComponent.text_contactExplanation" | translate }}</small>
</p>

@if (loading) {
  <div class="text-center">
    <fa-icon icon="spinner" animation="spin" size="2x"></fa-icon>
  </div>
}

@if (!loading) {
  <form [formGroup]="contactForm" novalidate>
    <div class="form-group mb-2">
      <label for="firstname" class="mb-0">{{ "Template.SupplierContactComponent.label_name" | translate }}</label>
      <div class="row">
        <div class="col">
          <input type="text" [class]="contactForm.controls['firstname'].disabled ? 'form-control-plaintext' : 'form-control'" formControlName="firstname" placeholder="{{ 'Template.SupplierContactComponent.placeholder_firstName' | translate }}" />
        </div>
        <div class="col">
          <input type="text" [class]="contactForm.controls['lastname'].disabled ? 'form-control-plaintext' : 'form-control'" formControlName="lastname" placeholder="{{ 'Template.SupplierContactComponent.placeholder_lastName' | translate }}" />
        </div>
      </div>
    </div>
    <div class="form-group mb-2">
      <label for="email" class="mb-0">{{ "Template.SupplierContactComponent.label_email" | translate }}</label>
      <input type="email" [class]="contactForm.controls['email'].disabled ? 'form-control-plaintext' : 'form-control'" formControlName="email" placeholder="{{ 'Template.SupplierContactComponent.placeholder_email' | translate }}" />
    </div>
    <div class="form-group mb-2">
      <label for="phone" class="mb-0">{{ "Template.SupplierContactComponent.label_phone" | translate }}</label>
      <input type="tel" [class]="contactForm.controls['phone'].disabled ? 'form-control-plaintext' : 'form-control'" formControlName="phone" placeholder="{{ 'Template.SupplierContactComponent.placeholder_phone' | translate }}" />
    </div>
    <button class="btn btn-sm btn-block w-100" (click)="showForm(!contactForm.controls['editing'].value)" type="button" [class]="contactForm.controls['editing'].value ? 'btn-outline-danger' : 'btn-secondary'">
      @if (!contactForm.controls['editing'].value) {
        <span>{{ "Template.SupplierContactComponent.btn_edit" | translate }}</span>
      }
      @if (contactForm.controls['editing'].value) {
        <span>{{ "Common.btn_cancel" | translate }}</span>
      }
      @if (!contactForm.controls['editing'].value) {
        <fa-icon icon="pencil-alt" class="ms-1"></fa-icon>
      }
      @if (contactForm.controls['editing'].value) {
        <fa-icon icon="circle-xmark" class="ms-1"></fa-icon>
      }
    </button>
    @if (contactForm.controls['editing'].value) {
      <button type="button" [attr.disabled]="saving ? '' : null" class="btn btn-secondary btn-sm mt-2 btn-block w-100" (click)="saveContact()">
        {{ "Template.SupplierContactComponent.btn_save" | translate }}
        @if (!saving) {
          <fa-icon icon="check" class="ms-1"></fa-icon>
        }
        @if (saving) {
          <fa-icon icon="spinner" animation="spin" class="ms-1"></fa-icon>
        }
      </button>
    }
  </form>
}
